<script>
import Validation from '@/plugins/validation'
import { Input, Textarea, AutocompleteSelect } from '@/components/formelements'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RetailerTag',
  props: ['id'],
  data() {
    return {
      ...Validation,
      dialog: false,
      categoryDialog: false,
      searched: false,
      tableLoading: false,
      tableLoadingTwo: false,
      newRetailerTag: true,
      loading: false,
      activeTreeItems: []
    }
  },
  components: {
    Input,
    Textarea,
    AutocompleteSelect
  },
  computed: {
    ...mapState({
      orgRetailerInfo: state => state.retailer.orgRetailerInfo,
      tableHeaders: state => state.retailerTag.tableHeaders,
      allLanguages: state => state.retailerTag.allLanguages,
      searchResults: state => state.retailerTag.searchResults,
      associatedCategories: state => state.retailerTag.associatedCategories,
      allCategoryTreeGroups: state => state.retailerTag.allCategoryTreeGroups,
      categoryTreeGroupID: state => state.retailerTag.categoryTreeGroupID,
      languageID: state => state.retailerTag.languageID
    }),
    ...mapGetters({
      allCategoryTrees: 'retailerTag/getTreeList'
    }),
    allLanguagesItems(){
      return this.allLanguages.map( lang => {
        return { text: lang.Name, value: lang.ID }
      })
    },
    categoryTreeGroupsList(){
      return this.allCategoryTreeGroups.map( type => {
        return { text: type.CategoryTreeGroupName, value: type.CategoryTreeGroupID }
      })
    },
  },
  watch: {
    categoryTreeGroupID: async function(){
      await this.$store.dispatch('retailerTag/GET_TREE_CATEGORIES')
    },
    languageID: async function(){
      await this.$store.dispatch('retailerTag/GET_TREE_CATEGORIES')
    },
  },
  methods: {
    async save(){
      if(this.$refs.newMSGForm.validate()) {
        await this.$store.dispatch('ui/SHOW_CONFIRM_DIALOG', {
          header: 'Are you sure?',
          message: `Do you want to create new MSG <span class="font-weight-black">${ this.createMsgName }</span>?`,
          action: 'msgSearch/INSERT_MSG',
          data: null,
          nextTickAction: '',
          nextTickData: {},
        })
      }
    },
    categoryTableHeader(){
      return [
        {
          text: 'Name',
          value: 'CategoryTreePathForwards'
        },
        {
          text: 'Category Tree Group',
          value: 'CategoryTreeGroupName'
        },
        {
          text: 'Action',
          value: 'Delete'
        },

      ]
    },
    async searchRetailerTag(){
      this.tableLoading = true
      await this.$store.dispatch('retailerTag/SEARCH_RETAILER_TAGS', { retailerid: this.id, itemsPerPage: 10, page: 1 })
      this.tableLoading = false
      this.searched = true
    },
    async pagination(e){
      if (!this.searched) return
      this.tableLoading = true
      const getOrder = function(e){
        if (e.sortDesc[0]) return 'desc'
        return 'asc'
      }
      let index = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('retailerTag/SEARCH_RETAILER_TAGS', { retailerid: this.id, itemsPerPage: e.itemsPerPage, page: index, sortBy: e.sortBy[0], order: getOrder(e) })
      this.tableLoading = false
    },
    createRetailerTag() {
      this.$store.dispatch('retailerTag/RESET')
      this.newRetailerTag = true
      this.dialog = true
    },
    async removeAssociation(item){
      await this.$store.dispatch('retailerTag/REMOVE_ASSOCIATION', item)
      await this.$store.dispatch('retailerTag/GET_ASSOCIATED_CATEGORIES')
    },
    async rowClick(e, {item}){
      this.newRetailerTag = false
      this.$store.dispatch('retailerTag/RESET')
      this.$store.dispatch('retailerTag/SET_CURRENT_TAG', item)
      this.dialog = true
      this.tableLoadingTwo = true
      await this.$store.dispatch('retailerTag/GET_ASSOCIATED_CATEGORIES')
      this.tableLoadingTwo = false
    },
    async updateRetailerTag(){
      if (this.$refs.retailerTagForm.validate()){
        if (this.newRetailerTag){
          await this.$store.dispatch('retailerTag/INSERT_RETAILER_TAG')
          this.newRetailerTag = false
        } else {
          await this.$store.dispatch('retailerTag/UPDATE_RETAILER_TAG')
          await this.$store.dispatch('retailerTag/SEARCH_RETAILER_TAGS', { retailerid: this.id, itemsPerPage: 10, page: 1 })
        }
        // await this.$store.dispatch('retailerTag/GET_PROMOTIONGROUPS_RETAILER_ID')
      }
    },
    async updateData(){
      await this.$store.dispatch('retailerTag/UPDATE_ASSOCIATIONS', this.activeTreeItems)
      await this.$store.dispatch('retailerTag/GET_ASSOCIATED_CATEGORIES')
    },
    async editCategory(){
      this.loading = true
      this.categoryDialog = true
      this.activeTreeItems = this.associatedCategories
      await this.$store.dispatch('retailerTag/GET_RETAILER_TREES')
      await this.$store.dispatch('retailerTag/GET_TREE_CATEGORIES')
      this.loading=false
    },
    updateList(ids){
      this.activeTreeItems = ids
    }
  }
}
</script>

<template>
  <v-form ref="searchForm">
    <v-container fluid>
      <v-row>
        <router-link style="text-decoration: none" class="pa-5 pt-0" :to="{ name: 'Retailer', params: { id: id } }"> 
          Retailer: {{ orgRetailerInfo.Name }} ({{ id }}) 
        </router-link>
      </v-row>
      <v-row justify="center">
        <v-col  cols="12" sm="8">
          <Input form="retailerTag" field="nameStartsWith" placeholder="" label="Retailer Tag Name Starts With" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col  cols="12" sm="8">
          <Input form="retailerTag" field="descripStartsWith" placeholder="" label="Retailer Tag Description Starts With" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="d-flex justify-end mb-6" cols="12" sm="8">
          <v-btn @click="createRetailerTag" depressed color="accent">
            <v-icon left>mdi-plus-box</v-icon>Create New Retailer Tag
          </v-btn>
          <v-btn @click="searchRetailerTag" class="ml-2" width="125px" depressed color="accent">
            Search<v-icon right>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="d-flex justify-center primary--text">Double click Row to edit Retailer Tag</p>
          <v-data-table
            :server-items-length="$store.state.retailerTag.totalOnServer"
            :headers="tableHeaders"
            :items="searchResults"
            :items-per-page="10"
            @update:options="pagination"
            :loading="tableLoading"
            @dblclick:row="rowClick"
            :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
          >
          </v-data-table>
        </v-col>
        <v-dialog persistent v-model="dialog" width="850">
          <v-form ref="retailerTagForm">
            <v-card>
              <v-card-title>
                <h1 class="primary--text"> Retailer Tag </h1>
              </v-card-title>
              <v-row>
                <v-col cols="12">
                  <v-card-text>
                    Retailer Tag ID: {{ $store.state.retailerTag.tagId }}
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <v-card-text class="py-0">
                    <Input form="retailerTag" field="tagName" :rules="[...required]" placeholder="" label="Retailer Tag Name" />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12">
                  <v-card-text class="py-0">
                    <Textarea form="retailerTag" field="tagText" placeholder="" label="Retailer Tag Text" />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <v-card-text class="py-0">
                    <Input form="retailerTag" field="tagImage" placeholder="" label="Retailer Tag Image Name" />  
                  </v-card-text>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-card-text class="py-0">
                    <Input form="retailerTag" field="tagDisplayOrder" :rules="[...optionalNumbersRule]" placeholder="" label="Display Order" />  
                  </v-card-text>
                </v-col>
              </v-row>
              <v-card-actions class="d-flex justify-end px-5 pb-5">
                <v-btn @click="dialog = false, newRetailerTag = true" width="100" color="secondary">
                  Close
                </v-btn>
                <v-btn @click="updateRetailerTag" width="125" color="primary">
                  <v-icon left>mdi-content-save</v-icon>Save
                </v-btn>
              </v-card-actions>
              <v-card v-if="!newRetailerTag" flat>
                <v-card-title>
                  Category Associations 
                  <v-btn @click="editCategory" class="ml-2" color="primary">
                    <v-icon left>mdi-pencil</v-icon> Edit
                  </v-btn>
                </v-card-title>
                <v-data-table
                  :headers="categoryTableHeader()"
                  :items="associatedCategories"
                  :items-per-page="10"
                  :loading="tableLoadingTwo"
                  :footer-props="{ 'items-per-page-options': [ 10, 25 , 50, -1 ], 'show-first-last-page': true } "
                >
                  <template v-slot:item.Delete=" { item }" >
                    <span>
                      <v-icon color="primary" @click="removeAssociation(item)">mdi-trash-can</v-icon>
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog persistent v-model="categoryDialog" width="800">
          <v-card>
            <v-card-title>
              <v-row>
                <v-col class="primary--text" cols="12">
                  Retailer: {{ $store.state.retailer.retailerInfo.Name }} - Tag Name: {{ $store.state.retailerTag.tagName }}
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-subtitle class="pb-0">
              <v-row>
                <v-col cols="12" sm="4">
                  <AutocompleteSelect dense form="retailerTag" field="categoryTreeGroupID" :items="categoryTreeGroupsList" label="Category Tree Group" />
                </v-col>
                <v-col cols="12" sm="4">
                  <AutocompleteSelect dense form="retailerTag" field="languageID" :items="allLanguagesItems" label="Language" />
                </v-col>
                <v-col cols="12" sm="4" class="d-flex justify-end">
                  <v-btn color="secondary" @click="categoryDialog = false">close</v-btn>
                  <v-btn color="primary" class="ml-2" @click="updateData"><v-icon left>mdi-content-save</v-icon>save</v-btn>
                </v-col>
              </v-row>
            </v-card-subtitle>
            <v-card-text>
              <v-col cols="12" v-if="allCategoryTrees.length == 0" align="center">
                <h1 class="error--text" > No Categories </h1>
              </v-col>
              <v-treeview
                v-if="!loading"
                dense
                selectable
                multiple-active
                selected-color="primary"
                :items="allCategoryTrees"
                :value="activeTreeItems"
                item-children="children"
                item-key="TreeID"
                item-text="CategoryTreePathForwards"
                @input="updateList"
                return-object
              ></v-treeview>
            </v-card-text>
            <v-card-actions class="d-flex justify-end px-5 pb-5">
              <v-btn color="secondary" @click="categoryDialog = false">close</v-btn>
              <v-btn color="primary" @click="updateData"><v-icon left>mdi-content-save</v-icon>save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-form>
</template>
